function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { KeyHandler } from '@deephaven/grid';
import IrisGridShortcuts from "../IrisGridShortcuts.js";
class ReverseKeyHandler extends KeyHandler {
  constructor(irisGrid) {
    super();
    _defineProperty(this, "irisGrid", void 0);
    this.irisGrid = irisGrid;
  }
  onDown(event) {
    if (IrisGridShortcuts.TABLE.REVERSE.matchesEvent(event)) {
      if (!this.irisGrid.isReversible()) {
        return false;
      }
      var reverse = this.irisGrid.state.reverse;
      this.irisGrid.reverse(!reverse);
      return true;
    }
    return false;
  }
}
export default ReverseKeyHandler;
//# sourceMappingURL=ReverseKeyHandler.js.map